import React, { useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";

import { DataContext } from '../data/DataContext';
import { DataContextType } from '../data_types/interfaces';

interface Props {
    children: React.ReactNode;
}

const ClubChecker = ({ children }: Props) => {
    const navigate = useNavigate();
    const context = useContext<DataContextType | undefined>(DataContext);
    const { isClubMember } = context || {};

    useEffect(() => {
        if (!isClubMember) {
            navigate('/dgv_club');
        }
    }, [navigate, isClubMember]);

    return <>{children}</>;
};

export default ClubChecker;
